import React from 'react';
import PropTypes from 'prop-types';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMReservationStatusView extends React.Component {
  
  constructor(props) {
    super(props);
  }
  
  render() {
    const reservation = this.props.reservation;
    let className = this.props.className + " ";
    className += SMFormatHelper.statusClassName(reservation);
    return (
      <p className={className}>{SMFormatHelper.statusText(reservation)}</p>
    );
  }
}
SMReservationStatusView.propTypes = {
  reservation: PropTypes.object.isRequired,
  className: PropTypes.string,
};
export default SMReservationStatusView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationStatusView.jsx